import env from 'enviro';

// This type will be imported from LowLevelAuthFlowView in a later branch
export type AuthFlowType = 'OAuth' | 'OAuthWithPolling' | 'Input';

export const oAuthRedirectOrigin = `https://oauth-redirect.hubspot${
  env.isQa() ? 'qa' : ''
}.com`;

export function isOAuth(type: AuthFlowType) {
  return type === 'OAuth' || type === 'OAuthWithPolling';
}

export function isOAuthWithoutPolling(type: AuthFlowType) {
  return type === 'OAuth';
}

export function isOAuthWithPolling(type: AuthFlowType) {
  return type === 'OAuthWithPolling';
}
